import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import type { LoginMethod } from '@linktivity/ars-neo';
import { BaseAuth } from '@link/share/stores';
import {
  buildLocalizedPath,
  buildPathWithRedirect,
  type ProfileGuardOptions
} from '@link/share/utils';
import ShareAuth from '@link/share/vendors/firebase';
import Login from './Login';
import styles from './loginContainer.module.css';

interface LoginContainerProps {
  auth: BaseAuth;
  firebase: ShareAuth;
  loginMethods?: LoginMethod[];
  profileGuard?: ProfileGuardOptions;
}

const LoginContainer = observer(
  ({ auth, firebase, loginMethods, profileGuard }: LoginContainerProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const skipOtpCheck = location.state?.skipOtpCheck as boolean | undefined;

    const handleAuthSuccess = useCallback(
      (redirectTo: string, isNewUser: boolean) => {
        navigate(
          buildPathWithRedirect(
            buildLocalizedPath('email-verification'),
            redirectTo
          ),
          {
            state: { isNewUser, skipOtpCheck, autoResendOtp: true },
            replace: true
          }
        );
      },
      [navigate, skipOtpCheck]
    );

    return (
      <div className={styles.login}>
        <Login
          auth={auth}
          loggedIn={auth.loggedIn}
          firebase={firebase}
          loginMethods={loginMethods}
          profileGuard={profileGuard}
          onAuthSuccess={handleAuthSuccess}
        />
      </div>
    );
  }
);

export default LoginContainer;
